module.exports = __webpack_public_path__ + "img/1080_17.4161fe46.jpg";